export default __webpack_public_path__ + "static/media/sticker-D.d8fbaeeb.png";